<template>
  <!-- <input type="date" :value="date" @change="change" /> -->
  <b-form-datepicker
    :locale="getDefaultLocale"
    v-model="model"
    v-bind="[$attrs, getLabels]"
    @input="input"
    :max="max"
    :reset-button="true"
    :show-decade-nav="true"
    :label-reset-button="getLabels.labelReset"
    :initial-date="getInitialDate"
    class="date-input mb-2"
    start-weekday="1"
  ></b-form-datepicker>
</template>

<script>

export default {
  inheritAttrs: false,
  props: {
    value: {
      required: false,
    },
    locale: {
      type: String,
      default: null,
    },
    isBirthDate: {
      type: Boolean,
      default: false
    },
    max:{
      required: false
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    
    getDefaultLocale() {
      const defaultLang = localStorage.getItem('language') ? localStorage.getItem('language') : 'tr';
      return defaultLang;
    },
    getLabels() {
      var labels = {
        tr: {
          labelPrevDecade: this.translate('dateInput.labelPrevDecade'),
          labelPrevYear: this.translate('dateInput.labelPrevYear'),
          labelPrevMonth: this.translate('dateInput.labelPrevMonth'),
          labelCurrentMonth: this.translate('dateInput.labelCurrentMonth'),
          labelNextMonth: this.translate('dateInput.labelNextMonth'),
          labelNextYear: this.translate('dateInput.labelNextYear'),
          labelNextDecade: this.translate('dateInput.labelNextDecade'),
          labelToday: this.translate('dateInput.labelToday'),
          labelSelected: this.translate('dateInput.labelSelected'),
          labelNoDateSelected: this.translate('dateInput.labelNoDateSelected'),
          labelCalendar: this.translate('dateInput.labelCalendar'),
          labelNav: this.translate('dateInput.labelNav'),
          labelHelp: this.translate('dateInput.labelHelp'),
          labelReset: this.translate('dateInput.labelReset'),
        },
      };

      return labels[this.getDefaultLocale] ?? {};
    },
    getInitialDate(){
      var today = new Date();
      
      if(this.isBirthDate)
        today.setFullYear(today.getFullYear() - 30);

      return today.toISOString();
    }
  },
  methods: {
    input(x) {
      this.$emit("input", x);
    },
  },
};
</script>